import Colors from '../../../../shared/assets/style/default/color';
import DeviceConfig from '@devices/config';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const Background = styled.img<React.CSSProperties>`
  background: ${Colors['background']};
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
  position: fixed;
  top: 0;
  width: ${1920 * Screen.widthRatio}px;
`;

export default withImage(Background, true);
